__turbopack_context__.v({
  "custom-alias-tip": "CustomAliasTip-module-scss-module__dZtUna__custom-alias-tip",
});
